import RecipientsNav from '@nkr/views/recipients/tabs';
import VoucherHolderAddEdit from '@nkr/views/voucher-holder/add-edit';
import { useState } from 'react';

interface IProps {
    donorId: number,
    voucherHolderId: number
}

const VoucherHolderContainer = (props: IProps) => {
    const [name, setName] = useState('');

    return (
        <>
            <RecipientsNav activeKey={'VOUCHER-HOLDER-EDIT'} centerId={0} recipientAlias={''} hasRecipientShield={false} isAdmin={true} voucherHolderFullname={name} onTabSelect={() => null} />

            <VoucherHolderAddEdit
                donorId={props.donorId}
                voucherHolderId={props.voucherHolderId}
                centerId={0}
                isAdmin={true}
                isAdminLogin={true}
                onLoaded={name => setName(name)} />
        </>
    );
}

export default VoucherHolderContainer;